import { useTranslation } from 'react-i18next';
import { useUIStore } from '@/store/uiStore';
import Sidebar from '@/components/common/Sidebar';
import TrialBanner from '@/components/common/TrialBanner';
import { Menu } from 'lucide-react';
import TeamUsersTab from '@/components/settings/TeamUsersTab';

export default function UsersPage() {
  const { t } = useTranslation();
  const { toggleSidebar } = useUIStore();

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 overflow-auto">
        <TrialBanner />
        <div className="p-6">
          <div className="flex items-center gap-3 mb-6">
            <button onClick={toggleSidebar} className="lg:hidden p-2 -ml-2 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg shrink-0">
              <Menu className="w-5 h-5" />
            </button>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">{t('users.title')}</h1>
              <p className="text-gray-500 text-sm">{t('users.subtitle')}</p>
            </div>
          </div>
          <TeamUsersTab />
        </div>
      </div>
    </div>
  );
}
